import API from '../../../constants/api';

export const FETCH_PRODUCT_LIST_REQUEST = '@@products/FETCH_PRODUCT_LIST_REQUEST';
export const FETCH_PRODUCT_LIST_FAILURE = '@@products/FETCH_PRODUCT_LIST_FAILURE';
export const FETCH_PRODUCT_LIST_SUCCESS = '@@products/FETCH_PRODUCT_LIST_SUCCESS';

export const CLEAR_PRODUCT_STATE = '@@products/CLEAR_PRODUCT_STATE';

export const fetchProductsForPurchaseOrder = (page, size, filters, warehouseId) => ({
    type: FETCH_PRODUCT_LIST_REQUEST,
    api: API.PRODUCT.GET_PRODUCTS_FOR_PURCHASE_ORDER,
    page,
    size,
    filters,
    warehouseId,
});

export const clearProductsState = () => ({
    type: CLEAR_PRODUCT_STATE,
});
